import PropType from 'prop-types';
import { useId } from 'react';
import MUICheckbox from '@mui/material/Checkbox';

const Checkbox = ({
  error,
  helper,
  label,
  readOnly,
  checked,
  ...props
}) => {
  const inputId = useId();
  return (
    <MUICheckbox
      id={inputId}
      label={label}
      checked={checked}
      error={error}
      helperText={helper}
      slotProps={{
        input: { readOnly },
      }}
      {...props}
    />
  );
};

Checkbox.propTypes = {
  helper: PropType.string,
  label: PropType.string,
  error: PropType.bool,
  value: PropType.string,
};

export default Checkbox;
